import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { APP_PRODUCT_NAME } from "../constants/app";
import { DOCUMENT_TYPES } from "../constants/enums/document-types";
import Api from "./api";

type validateDocumentResponse = {
    businessName: string;
    state: string;
    message: string;
    name: string;
    lastName: string;
    motherLastName: string;
};

type legalRepresentative = {
    documentId: string;
    documentType: string;
    employment: string;
    firstSurname: string;
    lastSurname: string;
    names: string;
};

export class PersonsApi {
    static validateDocument = (
        documentNumber: string,
        documentType: string
    ): Observable<validateDocumentResponse> => {
        const documentTypeCode =
            documentType === DOCUMENT_TYPES.RUC ? "6" : null;
        return Api.get(
            `ms-sp-consulta-contratantes-pga/prospeccion/v1/contratante/validar/${documentTypeCode}/${documentNumber}`
        ).pipe(map((resp) => resp.response));
    };

    static rucHasPolicy = (
        documentNumber: string,
        documentType: string
    ): Observable<boolean> => {
        return Api.post(
            `ms-sp-valida-contratantes-pga/prospeccion/v1/contratante`,
            {
                entity: {
                    idTransaction: null,
                    documentType,
                    documentNumber,
                    product: APP_PRODUCT_NAME,
                },
            }
        ).pipe(map((resp) => resp.response.flagPolicy));
    };

    static saveLegalRepresentative = (
        info: legalRepresentative
    ): Observable<boolean> => {
        return Api.post(
            "ne-representanteslegales-vida-ley-empleados-vda/cotizacion/v1/legalRepresentative/save",
            {
                entity: {
                    ...info,
                },
            }
        ).pipe(
            map(() => true),
            catchError(() => of(true))
        );
    };
}
